import { Store } from "vuex";

class StoreRef {
	storeRef: Store<any> | null =null
	get instance () {
		if (!this.storeRef) {
			throw new Error("Store ref not inited");
		}
		return this.storeRef;
	}

	init (store: Store<any>) {
		this.storeRef = store;
	}
}

export default new StoreRef();
